import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { LoaderService } from "src/app/loader/loader.service";
import { environment } from "src/environments/environment";
import { Payment } from "../models/payment";
import { ChargesStoreService } from "../services/charges-store.service";

@Component({
  selector: "app-estornados-charges",
  templateUrl: "./estornados-charges.component.html",
  styleUrls: ["./estornados-charges.component.scss"],
})
export class EstornadosChargesComponent implements OnInit {
  env;
  page = 1;
  pageSize = 10;
  collectionSize = 0;

  payments: Payment[];

  private unsubscribe$ = new Subject();

  constructor(public router: Router, public chargesStore: ChargesStoreService, private loaderService: LoaderService) {
    this.env = environment;
  }

  ngOnInit() {
    this.getEstornadosPayments();
  }

  getEstornadosPayments() {
    this.chargesStore.estornadosPayments$.pipe(takeUntil(this.unsubscribe$)).subscribe(paymentResult => {
      this.pageSize = paymentResult.limit;
      this.page = paymentResult.page;

      this.collectionSize =
        paymentResult.total_docs !== undefined && paymentResult.total_docs !== null
          ? paymentResult.total_docs
          : paymentResult.result.length;
      this.payments = paymentResult.result;
    });
  }

  getTipoPayment(payment: Payment): string {
    return this.chargesStore.getTipoPayment(payment);
  }

  async onChangePagination() {
    const loader = await this.loaderService.notifica({
      title: "Atualizando paginação...",
      date: moment().toISOString(),
      type: "loading",
    });

    await this.chargesStore.getPayments(this.env.selected.cnpj, this.pageSize, this.page);

    loader.dismiss();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
